import { dispatch, State, useSelector } from '@ui-complex/react-state';
import { DATE_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';

interface IState {
  data: { date: string; type: 'MONTH' | 'YEAR' };
  key?: string;
  result: { date: string; type: 'MONTH' | 'YEAR' | 'DAY' };
}

// console.log(UIC, 'UIC');

export const profileReport: IState = {
  data: {
    date: dayjs().endOf('month').format(DATE_FORMAT),
    type: 'MONTH'
  },
  result: {
    date: dayjs().endOf('month').format(DATE_FORMAT),
    type: 'MONTH'
  },
  key: 'leadCount'
};

export const useProfileReport = <T, _>(myFunction: (state: typeof profileReport) => T) =>
  useSelector(profileReport, myFunction);

export const profileReportDispatch = <T, _>(myFunction: (state: typeof profileReport) => T) =>
  dispatch(profileReport, myFunction);

export const StateProfileReport = <T, _>({
  children,
  selector
}: {
  children: (props: T) => React.ReactElement;
  selector: (state: typeof profileReport) => T;
}) => <State state={profileReport} selector={selector} children={children} />;
